import { ForwardedRef, forwardRef, MouseEvent, KeyboardEvent } from "react";

type IButtonProps = {
  text: string;
  styels?: string;
  disabled?: boolean;
  onClick(e: MouseEvent<HTMLButtonElement>): void;
  onKeydown?(e: KeyboardEvent<HTMLButtonElement>): void;
};

const Button = (
  { text, styels = "", disabled, onClick, onKeydown }: IButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) => {
  return (
    <button
      ref={ref}
      className={"btn" + " " + styels}
      disabled={disabled}
      onClick={onClick}
      // onKeyDown={(event) => {
      //   console.log(event);
      //   if (event.key === "Enter") {
      //     console.log("인털키 클릭");
      //   }
      // }}
    >
      {text}
    </button>
  );
};

export default forwardRef<HTMLButtonElement, IButtonProps>(Button);
